/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketBarcodeResVo } from './MarketBarcodeResVo';
import {
    MarketBarcodeResVoFromJSON,
    MarketBarcodeResVoFromJSONTyped,
    MarketBarcodeResVoToJSON,
    MarketBarcodeResVoToJSONTyped,
} from './MarketBarcodeResVo';
import type { SkuProductResVo } from './SkuProductResVo';
import {
    SkuProductResVoFromJSON,
    SkuProductResVoFromJSONTyped,
    SkuProductResVoToJSON,
    SkuProductResVoToJSONTyped,
} from './SkuProductResVo';

/**
 * 
 * @export
 * @interface SkuCompositionResVo
 */
export interface SkuCompositionResVo {
    /**
     * 构成商品信息
     * @type {Array<SkuProductResVo>}
     * @memberof SkuCompositionResVo
     */
    products?: Array<SkuProductResVo>;
    /**
     * 商品条形码信息
     * @type {Array<MarketBarcodeResVo>}
     * @memberof SkuCompositionResVo
     */
    barcodes?: Array<MarketBarcodeResVo>;
}

/**
 * Check if a given object implements the SkuCompositionResVo interface.
 */
export function instanceOfSkuCompositionResVo(value: object): value is SkuCompositionResVo {
    return true;
}

export function SkuCompositionResVoFromJSON(json: any): SkuCompositionResVo {
    return SkuCompositionResVoFromJSONTyped(json, false);
}

export function SkuCompositionResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuCompositionResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(SkuProductResVoFromJSON)),
        'barcodes': json['barcodes'] == null ? undefined : ((json['barcodes'] as Array<any>).map(MarketBarcodeResVoFromJSON)),
    };
}

export function SkuCompositionResVoToJSON(json: any): SkuCompositionResVo {
    return SkuCompositionResVoToJSONTyped(json, false);
}

export function SkuCompositionResVoToJSONTyped(value?: SkuCompositionResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(SkuProductResVoToJSON)),
        'barcodes': value['barcodes'] == null ? undefined : ((value['barcodes'] as Array<any>).map(MarketBarcodeResVoToJSON)),
    };
}

